import domContentLoaded from 'dom-content-loaded';
import { throttle } from 'throttle-debounce';

const scrollAddClass = () => {
	// const scrollElms = document.querySelectorAll('[class*="js_fade"]'); // 表示させる要素
	// const windowHeight = window.innerHeight; // ウインドウの高さ
	// const scrollValue = window.pageYOffset; // スクロール量
	// const windowOffset = 0; // 表示させる時のオフセット
	// if (scrollValue > 100) {
	// 	document.body.classList.add('is_scrolled');
	// } else {
	// 	document.body.classList.remove('is_scrolled');
	// }
	// for (let i = 0; i < scrollElms.length; i += 1) {
	// 	const scrollTop = scrollElms[i].getBoundingClientRect().top + scrollValue;
	// 	if (scrollValue > scrollTop - windowHeight + windowOffset) {
	// 		scrollElms[i].classList.add('is_appeared');
	// 	}
	// }
};

export default () => {
	window.addEventListener('load', scrollAddClass);
	window.addEventListener('scroll', throttle(100, () => {
		scrollAddClass();
	}));
	window.addEventListener('resize', throttle(100, () => {
		scrollAddClass();
	}));
};
